module.exports = __webpack_public_path__ + "img/no_image.241adea7.svg";